import axiosConfig from "./axiosConfig";

export interface PopulateDemoActualsRequest {
  startMonth: string;
  endMonth: string;
  scalingFactor?: number;
  variationPercent?: number;
  seed?: number;
}

export interface PopulateDemoActualsMonthResult {
  month: string;
  readingsCount: number;
  factor: number;
}

export interface PopulateDemoActualsResponse {
  siteId: string;
  monthsWritten: number;
  months: PopulateDemoActualsMonthResult[];
}

const postPopulateDemoActuals = async (
  authToken: string,
  siteId: string,
  body: PopulateDemoActualsRequest
): Promise<PopulateDemoActualsResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/ingestion/demo_actuals`,
    body,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postPopulateDemoActuals;
